export enum RoomDetailsMountComponent {
  HotelViewRoomsSection = `hotelViewRoomsSection`
}
